import { render, staticRenderFns } from "./vc-input-icon.vue?vue&type=template&id=1c1aa74d&scoped=true&"
import script from "./vc-input-icon.vue?vue&type=script&lang=js&"
export * from "./vc-input-icon.vue?vue&type=script&lang=js&"
import style0 from "./vc-input-icon.vue?vue&type=style&index=0&id=1c1aa74d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1aa74d",
  null
  
)

export default component.exports